export const makeActionCreator = (type, ...argNames) => (...args) => {
  const action = {
    type,
    payload: {}
  }
  argNames.forEach((arg, index) => {
    action.payload[argNames[index]] = args[index]
  })

  return action
}

export const removeObjectKey = (object, deleteKey) => {
  return Object.keys(object).filter(key => key !== deleteKey).reduce((result, current) => {
    result[current] = object[current]
    return result
  }, {})
}

export const removeArrayElement = (array, element) => {
  const index = array.indexOf(element)
  return [
    ...array.slice(0, index),
    ...array.slice(index + 1)
  ]
}


// WEBPACK FOOTER //
// ./util/state.js